const STORM_TYPE = {
  HAIL: 'HAIL',
  TORNADO: 'TORNADO',
  MESOCYCLONE: 'MESOCYCLONE',
};

export { STORM_TYPE };
